'use client';

import { Switch } from '@/components/ui/switch';

const CustomSwitch = ({ checked }: { checked: boolean }) => {
    return (
        <div className='relative inline-grid h-10 grid-cols-[1fr_1fr] items-center text-sm font-medium'>
            <Switch
                checked={checked}
                className='peer data-[state=checked]:bg-success data-[state=unchecked]:bg-background absolute inset-0 p-1 h-[2.5rem] w-full rounded-md [&_span]:z-10 [&_span]:h-full [&_span]:w-1/2 [&_span]:rounded-sm [&_span]:transition-transform [&_span]:duration-300 [&_span]:ease-custom-ease [&_span]:data-[state=checked]:translate-x-full [&_span]:data-[state=checked]:rtl:-translate-x-8.75 [&_span]:data-[state=checked]:bg-gray-200 [&_span]:bg-destructive'
                aria-label='Square switch with permanent text indicators'
            />
            <span className='pointer-events-none relative ml-0.5 flex items-center justify-center px-2 text-center transition-transform duration-300 ease-custom-ease peer-data-[state=checked]:invisible peer-data-[state=unchecked]:translate-x-full peer-data-[state=unchecked]:rtl:-translate-x-full'>
                <span className='text-[12px] font-bold uppercase'>
                    disabled
                </span>
            </span>
            <span className='peer-data-[state=checked]:text-white pointer-events-none relative mr-0.5 flex items-center justify-center px-2 text-center transition-transform duration-300 ease-custom-ease peer-data-[state=checked]:-translate-x-full peer-data-[state=unchecked]:invisible peer-data-[state=checked]:rtl:translate-x-full'>
                <span className='text-[12px] font-extrabold uppercase'>
                    Enabled
                </span>
            </span>
        </div>
    );
};

export default CustomSwitch;
